/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */

import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {Harlequin} from "../Harlequin";
import {HarlequinSoundConfig} from "../HarlequinSoundConfig";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {HarlequinParsedGameData} from "../server/data/HarlequinParsedGameData";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {HarlequinGameModuleConfig} from "../HarlequinGameModuleConfig";
import {HarlequinSpinReelController} from "../spinreel/HarlequinSpinReelController";
import {Timeline, TimelineLite} from "gsap";

export class ReelStop implements GameRoundPresentation {
    private readonly _reelId:number;
    private _stopDelay:number;
    private _quickStopDelay:number;
    private _data:HarlequinParsedGameData;
    private _scatterPositions:number [] = [];
    private _inBaseGame:boolean = false;
    private _nearWinReels:boolean [];

    private _hasWild:boolean = false;
    private _isFullStacked:boolean = false;
    private _aborted:boolean = false;
    private _freespinTriggeredThisSpin:boolean = false;
    private _soundTl:TimelineLite;

    stagger?:number;
    abortStagger?:number;
    private _tl:Timeline;


    constructor(reelId:number, stagger?:number, abortStagger?:number) {
        this._reelId = reelId;
        this._stopDelay = Harlequin.timelineReelsController.getReelConfig(this._reelId).stopDelay;
        this._quickStopDelay = Harlequin.timelineReelsController.getReelConfig(this._reelId).quickStopDelay;

        //Override config
        if (stagger != undefined) {
            this._stopDelay = stagger;
        }
        if (abortStagger != undefined) {
            this._quickStopDelay = abortStagger;
        }

        this.stagger = this._stopDelay;
        this.abortStagger = this._quickStopDelay;
    }

    prepare(data:ParsedServerData):void {
        this._aborted = false;
        this._data = <HarlequinParsedGameData>data;
        this._scatterPositions = data.scatterPositions || [];
        this._inBaseGame = (data.mode === "NORMAL" || data.mode === "WILD_RESPIN");
        this._nearWinReels = this._data.nearWinReels;
        this._hasWild = (this._data.doReelNudge) ? this._data!.doReelNudge[this._reelId] : false;
        this._isFullStacked = !this._hasWild && this._data.wildOverlayReels && this._data.wildOverlayReels[this._reelId] && !this._data.wildOverlayReelsBefore[this._reelId + 1];
        this._freespinTriggeredThisSpin = this._data.freespinTriggeredThisSpin;


        if (this._reelId === 0) {
            // Resetting sound counter for every round
            HarlequinGameModuleConfig.harlequinScatterCollectorView.soundCounter = 0;
        }
    }

    public getAnimation(data:ParsedGameData):Timeline {
        const nwStagger:number = 0.8;
        this.stagger = GameSetting.isFastSpin ? this._quickStopDelay : this._stopDelay;
        let reelController:HarlequinSpinReelController = <HarlequinSpinReelController>Reels.getReel(this._reelId);

        reelController.updateGameData(this._data);

        let stopSound = HarlequinSoundConfig.instance.REELS_DEFAULT_BOUNCE[this._reelId];

        if (this._nearWinReels[this._reelId]) {
            this.stagger += nwStagger;
        }

        const tl:Timeline = Harlequin.timelineReelsController.stopSpin(this._reelId, this._data, false);


        //Wild
        if (this._hasWild || this._isFullStacked) {
            tl.add(() => {
                HarlequinGameModuleConfig.nearWinView.playWildOmenOnReel(this._reelId);
            }, 0);
            stopSound = HarlequinSoundConfig.instance.WILD_LAND;
        }


        if (this._scatterPositions[this._reelId] > -1) {
            stopSound = HarlequinGameModuleConfig.harlequinScatterCollectorView.getScatterLandingSound(this._inBaseGame);
        }

        const soundTl:TimelineLite = new TimelineLite();


        /*
                if (this._inBaseGame && this._reelId >= 1 && this._reelId <= 3) {
                    // TODO: check if to do random stacked wild attention (1/10?)
                    //tl.add(this.getStackedWildAttention());
                }
        */


        tl.add(() => {
            if (this._reelId === 3 && /*this._scatterPositions[2] > -1 && this._scatterPositions[3] < 0 &&*/ this._nearWinReels[3]) {
                //if(!this._data.wildOver
                SlotGame.sound.stopEffect(HarlequinSoundConfig.instance.ANTICIPATION);
                //}
                //SlotGame.sound.playEffect(HarlequinSoundConfig.instance.ANTICIPATION_FAIL);
            }
            if (this._reelId === 3 && !this._aborted && this._nearWinReels[3] && this._freespinTriggeredThisSpin /*this._scatterPositions[1] > -1 && this._scatterPositions[2] > -1 && this._scatterPositions[3] > -1 && this._inBaseGame*/) {
                SlotGame.sound.stopEffect(HarlequinSoundConfig.instance.ANTICIPATION);
                // HarlequinGameModuleConfig.harlequinScatterCollectorView.playScatterLandSound();
            }
        }, this.stagger - 0.045);


        //Reset stuff
        if (this._nearWinReels[this._reelId]) {
            tl.add(() => {
                //HarlequinGameModuleConfig.nearWinView.reset();
            });
        }

        if (this._nearWinReels[3] && this._reelId >= 3) {
            tl.add(() => {
                HarlequinGameModuleConfig.nearWinView.reset();
            }, this.stagger);
        }

        if (this._hasWild || this._isFullStacked) {
            tl.add(() => {
                HarlequinGameModuleConfig.nearWinView.hideWildOmens();
            }, this.stagger - 0.2)
        }


        //Landing Sound
        const bounceTiming = -0.28;
        const bounceTime = tl.duration() + bounceTiming;
        tl.add([
            () => {
                if (stopSound === HarlequinSoundConfig.instance.WILD_LAND && this._data.wildDrop[4]) {
                    SlotGame.sound.playEffect(HarlequinSoundConfig.instance.REELS_DEFAULT_BOUNCE[this._reelId]);
                } else {
                    SlotGame.sound.playEffect(stopSound);
                }
            },
            () => {
                if (this._nearWinReels[this._reelId]) {

                    // TODO: Better case handling for antip fail
                    //const _scattersCollected:number = 2;
                    //const _scatterPositions:number [] = [-1, 0, -1, -1, -1];
                    //const _nearWinReels:boolean [] = [false, false, true, true, false];
                    const lastIndex:number = this._nearWinReels.lastIndexOf(true);


                    // TODO: Make a calculation for knowing exactly on witch scatter the bonus gets triggered.
                    if (this._freespinTriggeredThisSpin && this._nearWinReels[this._reelId] && this._reelId === lastIndex) {
                        //debugger;
                        SlotGame.sound.playEffect(HarlequinSoundConfig.instance.SCATTER_LAND[2]);
                        HarlequinGameModuleConfig.bonusSplash.playAnimation();
                    }

                    if (this._data.nextMode !== "FREESPIN" && this._data.nextMode !== "WILD_RESPIN" && this._nearWinReels[this._reelId] && this._reelId === lastIndex) {
                        //console.log("NW REEL ID: " + this._reelId);
                        SlotGame.sound.playEffect(HarlequinSoundConfig.instance.ANTICIPATION_FAIL);
                    }
                }
            }
        ], bounceTime);


        if (this._reelId === 4) {
            tl.add(() => SlotGame.sound.stopEffect(HarlequinSoundConfig.instance.REELS_SPINNING_START_ON_SPIN_START), bounceTime);
        }


        this._tl = tl;
        return tl;
    }

    protected getStackedWildAttention():Timeline {
        const tl:Timeline = new TimelineLite();

        // TODO: Decide if slowmo
        /*tl.add(() => {
            EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.ADD_SLOW_ATTENTION_SPIN_SYMBOL_TO_REEL, {
                reelId : this._reelId,
                symName : "W*0",
                spinSpeed : 0.6,
                startPosition : -3,
                steps : 5,
                symbolState : HarlequinGameConfig.instance.SYMBOL_STATES.normal// Add state with attention animation
            }));
        });*/
        //tl.add(() => {}, 1);


        return tl;
    }

    public abort(isActive:boolean, data:ParsedGameData):Timeline | null {
        this._aborted = true;
        if (isActive) {
            return this._tl;
        }
        this._tl = this.getAnimation(data);
        return this._tl;
    }

}